/**
 * Detects whether the current document is rendered in right-to-left (RTL) direction.
 *
 * @returns `true` if the document is in RTL mode, `false` for left-to-right (LTR)
 *
 * @remarks
 * This utility checks both `document.body.dir` and `document.documentElement.dir` attributes
 * to determine the document's text direction. This is essential for supporting internationalization
 * and RTL languages like Arabic, Hebrew, and Persian. The function returns `true` if either
 * attribute is explicitly set to `'rtl'`.
 *
 * @example
 *
 * ```typescript
 * // Adapt component positioning based on text direction
 * const marginProperty = isRtl() ? 'marginRight' : 'marginLeft';
 * ```
 */
export function isRtl(): boolean {
  return document.body.dir === 'rtl' || document.documentElement.dir === 'rtl';
}
